
import modalConstants from '~/store/modal/-constants'

export default {
  name: 'SectionBrochureButton',
  props: {
    data: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0
    },
    hash: {
      required: true,
      type: String,
      default: ''
    }
  },
  computed: {
    locale() {
      return this.$i18n?.locale || 'en'
    },
    activeProject() {
      return this.$store.getters.getActiveProjectData;
    },
  },
  methods: {
    handleDownloadBrochure() {
      if (window && 'analyticsLayer' in window) {
        window.analyticsLayer.send({
          event: 'download_brochure_open',
          payload: {
            zone: 'brochure'
          }
        })
      }
      this.$store.dispatch(modalConstants.withNamespace(modalConstants.action.CHANGE_MODAL_STATE), {
        showModal: true,
        modalType: 'download-brochure',
        data: {
          projectName: this.activeProject.name,
          brochureUrl: this.resourceUrl(this.data.buttonUrl)
        }
      })
      document.body.classList.add('disable-scroll')
    },
    resourceUrl(img) {
      if (img && img.includes('://')) {
        return img
      }
      return `${this.$store.getters.cdnBase}/${img}`
    }
  }
}
